import Vue from 'vue'
import sinisterInWP from '../../transformers/sinister/sinisterInWP'

export default (userId) => {
  return Vue.$http.get(`workplan/list-sinister-resident/${userId}/`)
  .then((response) => {
    const data = sinisterInWP.fetchCollection(response.data)
    return data
  })
  .catch((error) => {
    return []
  })
}



// WEBPACK FOOTER //
// ./src/services/sinister/fetchSinistersInWP.js